import axios from 'axios';
import {ACCESS_TOKEN_NAME, USER_ID, USER_NAME} from "@/constant";
import {authLogout} from "@/security/index";
import {FULL_NAME, LOCATION_CODE_NAME, USER_POSITION} from './constant';
import AES from "crypto-js/aes";
import enc from "crypto-js/enc-utf8";

const API_PATH = process.env.API_ENDPOINT;
export default {
  handleError(router, error) {
    if (error && error.response && error.response.status === 401 || error && error.status === 401) {
      authLogout();
    } else if (error && error.response && error.response.status === 403 || error && error.status === 403) {
      router.push('/errors/403');
    } else if (error && error.response && error.response.status === 404 || error && error.status === 404) {
      router.push('/errors/404');
    } else if (error && error.response && error.response.status === 500 || error && error.status === 503 || error && error.status === 400 || error.returnCode == -1) {
      router.push('/errors/500');
    } else if (error.returnCode === undefined) {
      authLogout();
    }
  },
  setupErrorModel(errorResponse, dataRef) {
    if (!errorResponse instanceof Array) {
      return;
    }
    for (let attr in dataRef) {
      var attrValue = dataRef[attr];
      if (attrValue['data'] && attrValue['data']['name'] &&
        attrValue['data']['validator'] && errorResponse[attrValue['data']['name']]) {
        attrValue['data']['validator']['isValid'] = false;
        attrValue['data']['validator']['errorMessage'] = errorResponse[attrValue['data']['name']];
      }
    }
  },
  getStringError(errorResponse) {
    let strResult = '';
    if (typeof errorResponse === 'string') {
      return errorResponse;
    }
    for (let attr in errorResponse) {
      strResult += errorResponse[attr] + ', '
    }
    if (strResult) {
      strResult = strResult.substring(0, strResult.length - 2);
    } else {
      strResult = 'Hệ thống đang bận, xin thử lại sau ít phút';
    }
    return strResult;
  },
  validResponse(router, response) {
    if (response.returnCode !== 1) {
      this.handleError(router, response);
      return false;
    } else {
      return true;
    }
  },
  getValue(component) {
    return component.data.model;
  },
  setValue(component, value) {
    component.data.model = value;
  },
  getFirstOptionValue(component) {
    return component.getFirstOptionValue();
  },
  setFirstOptionSelected(component) {
    component.setFirstOptionSelected();
  },
  getText(component) {
    return component.getText;
  },
  enterEventHandler(event, callBack) {
    if (event.key === 'Enter') {
      callBack();
    }
  },
  setupDataSubmit(modelObject) {
    var dataSubmit = {};
    for (let attr in modelObject) {
      if (!(modelObject[attr].data && modelObject[attr].data.name && modelObject[attr].data.model !== undefined && modelObject[attr].data.formatter === undefined)) {
        continue;
      }
      let element = modelObject[attr];
      dataSubmit[element.data.name] = element.data.model;
    }
    return dataSubmit;
  },
  setupDataResponse(modelObject, dataResponse) {
    let response = {};
    for (let attr in modelObject) {
      if (!(modelObject[attr].data && modelObject[attr].data.name && modelObject[attr].data.model !== undefined)) {
        continue;
      }
      let element = modelObject[attr];
      let modelVal = dataResponse[element.data.name];
      if (!element.data.formatter) {
        response[element.data.name] = modelVal;
      }
      if (element.data.formatter) {
        modelVal = element.data.formatter(modelVal);
      }
      element.data.model = modelVal;
    }
    return response;
  },
  validDataSubmit(modelObject) {
    let isValid = true;
    for (let attr in modelObject) {
      if (!(modelObject[attr].data && modelObject[attr].data.name && modelObject[attr].data.validator !== undefined)) {
        continue;
      }
      let element = modelObject[attr];
      isValid &= element.data.validator.valid();
    }
    return isValid;
  },
  valid(component) {
    return component.data.validator.valid();
  },
  loadDataSource(dataSource) {
    var _dataSubmit;
    var hasDataRef = dataSource.dataRef !== undefined;
    var hasLoading = dataSource.loading !== undefined;
    var hasBtnCallAjax = typeof dataSource.btnCallAjaxs === "function" && dataSource.btnCallAjaxs().length !== 0;
    var that = this;
    if (dataSource.valid !== undefined && dataSource.valid == false) {
      return;
    }
    if (hasDataRef && !this.validDataSubmit(dataSource.dataRef())) {
      return;
    }
    if (dataSource.dataSubmit) {
      _dataSubmit = dataSource.dataSubmit();
    }
    if (hasDataRef) {
      _dataSubmit = this.setupDataSubmit(dataSource.dataRef());
    }

    if (_dataSubmit && !dataSource.ignoreDefaultData) {
      // _dataSubmit.userName = localStorage.getItem(USER_NAME);
      // _dataSubmit.userId = localStorage.getItem(USER_ID);
      // _dataSubmit.userLocationCode = localStorage.getItem(LOCATION_CODE_NAME);
      // _dataSubmit.fullName = localStorage.getItem(FULL_NAME);
      // _dataSubmit.userPosition = localStorage.getItem(USER_POSITION);
    }

    // hasDataRef &&
    if (dataSource.dataValid && this.isDataClone(dataSource.dataValid(), _dataSubmit)) {
      if (dataSource.validFalseCallback) {
        dataSource.validFalseCallback();
      }
      return;
    }
    if (hasLoading) {
      dataSource.loading.value = true;
    }
    if (hasBtnCallAjax) {
      for (let btn of dataSource.btnCallAjaxs()) {
        btn.disabled = true;
      }
    }
    var _successCallback = function (response) {
      if (hasLoading) {
        dataSource.loading.value = false;
      }
      if (hasBtnCallAjax) {
        for (let btn of dataSource.btnCallAjaxs()) {
          btn.disabled = false;
        }
      }
      if (hasDataRef && dataSource.dataValid) {
        var dataCahce = dataSource.dataValid();
        that.copyProperties(dataCahce, _dataSubmit);
      }
      dataSource.successCallback(response);
    }
    var _errorCallback = function (error) {
      if (hasLoading) {
        dataSource.loading.value = false;
      }
      if (hasBtnCallAjax) {
        for (let btn of dataSource.btnCallAjaxs()) {
          btn.disabled = true;
        }
      }
      dataSource.errorCallback(error);
    }

    if (dataSource && dataSource.type && dataSource.type === 'PUT') {
      this.putApi(dataSource.url, _dataSubmit, dataSource.options, dataSource.isJsonContentType, _successCallback, _errorCallback);
    } else if (dataSource && dataSource.type && dataSource.type === 'DELETE') {
      this.deleteApi(dataSource.url, _dataSubmit, dataSource.options, dataSource.isJsonContentType, _successCallback, _errorCallback);
    } else if (dataSource && dataSource.type && dataSource.type === 'GET') {
      this.getApi(dataSource.url, _dataSubmit, dataSource.options, dataSource.isJsonContentType, _successCallback, _errorCallback);
    } else {
      this.postApi(dataSource.url, _dataSubmit, dataSource.options, dataSource.isJsonContentType, dataSource.isMultiPartFormData, dataSource.isRequestBearerToken, _successCallback, _errorCallback);
    }
  },

  getApi(path, data, options, isJsonContentType, isMultiPartFormData, isRequestBearerToken, successCallBack, errorCallBack) {
    options = options || {};
    options.headers = options.headers || {};
    if (isJsonContentType === undefined) {
      isJsonContentType = true;
    }
    if (isMultiPartFormData === undefined) {
      isMultiPartFormData = false;
    }
    if (isRequestBearerToken === undefined) {
      isRequestBearerToken = true;
    }
    let _dataSubmit = null;
    let defaultHeader = {}
    if (isRequestBearerToken) {
      let header = {'Authorization': 'Bearer ' + this.getAccessToken()}
      defaultHeader = header;
    }
    let customHeaders = $.extend(defaultHeader, options.headers);

    options.headers = customHeaders;
    if (data && isMultiPartFormData) {
      _dataSubmit = data;
      options.headers['content-type'] = 'multipart/form-data';
    } else if (data && isJsonContentType) {
      data = {...data}
      _dataSubmit = data;
      options.headers['content-type'] = 'application/json;charset=utf-8';
    } else if (data && data instanceof Object) {
      options.headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8';
      data = {...data}
      _dataSubmit = '';
      for (var attrName in data) {
        _dataSubmit += attrName + '=' + data[attrName] + '&';
      }
      _dataSubmit = _dataSubmit.substring(0, _dataSubmit.length - 1);
    } else if (data) {
      options.headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8';
      data = {...data}
      _dataSubmit = data;
    }

    axios.get(API_PATH + path, _dataSubmit, options).then(response => {
      successCallBack(response);
    }).catch(error => {
      console.log(error);
      errorCallBack(error);
    });
  },

  postApi(path, data, options, isJsonContentType, isMultiPartFormData, isRequestBearerToken, successCallBack, errorCallBack) {
    options = options || {};
    options.headers = options.headers || {};
    if (isJsonContentType === undefined) {
      isJsonContentType = true;
    }
    if (isMultiPartFormData === undefined) {
      isMultiPartFormData = false;
    }
    if (isRequestBearerToken === undefined) {
      isRequestBearerToken = true;
    }
    let _dataSubmit = null;
    let defaultHeader = {}
    if (isRequestBearerToken) {
      let header = {'Authorization': 'Bearer ' + this.getAccessToken()}
      defaultHeader = header;
    }
    let customHeaders = $.extend(defaultHeader, options.headers);

    options.headers = customHeaders;
    if (data && isMultiPartFormData) {
      _dataSubmit = data;
      options.headers['content-type'] = 'multipart/form-data';
    } else if (data && isJsonContentType) {
      data = {...data}
      _dataSubmit = data;
      options.headers['content-type'] = 'application/json;charset=utf-8';
    } else if (data && data instanceof Object) {
      options.headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8';
      data = {...data}
      _dataSubmit = '';
      for (var attrName in data) {
        _dataSubmit += attrName + '=' + data[attrName] + '&';
      }
      _dataSubmit = _dataSubmit.substring(0, _dataSubmit.length - 1);
    } else if (data) {
      options.headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8';
      data = {...data}
      _dataSubmit = data;
    }

    axios.post(API_PATH + path, _dataSubmit, options).then(response => {
      successCallBack(response);
    }).catch(error => {
      console.log(error);
      errorCallBack(error);
    });
  },

  putApi(path, data, options, isJsonContentType, successCallBack, errorCallBack) {
    options = options || {};
    options.headers = options.headers || {};
    if (isJsonContentType === undefined) {
      isJsonContentType = true;
    }
    let _dataSubmit = null;
    let defaultHeader = {
      'Authorization': 'Bearer ' + this.getAccessToken(),
    }
    let customHeaders = $.extend(defaultHeader, options.headers);

    options.headers = customHeaders;

    if (data && isJsonContentType) {
      _dataSubmit = data;
      options.headers['content-type'] = 'application/json;charset=utf-8';
    } else if (data && data instanceof Object) {
      options.headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8';
      _dataSubmit = '';
      for (var attrName in data) {
        _dataSubmit += attrName + '=' + data[attrName] + '&';
      }
      _dataSubmit = _dataSubmit.substring(0, _dataSubmit.length - 1);
    } else if (data) {
      options.headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8';
      _dataSubmit = data;
    }

    axios.put(API_PATH + path, _dataSubmit, options).then(response => {
      successCallBack(response);
    }).catch(error => {
      console.log(error);
      errorCallBack(error);
    });
  },

  deleteApi(path, data, options, isJsonContentType, successCallBack, errorCallBack) {
    options = options || {};
    options.headers = options.headers || {};
    if (isJsonContentType === undefined) {
      isJsonContentType = true;
    }
    let _dataSubmit = null;
    let defaultHeader = {
      'Authorization': 'Bearer ' + this.getAccessToken(),
    }
    let customHeaders = $.extend(defaultHeader, options.headers);

    options.headers = customHeaders;

    if (data && isJsonContentType) {
      _dataSubmit = data;
      options.headers['content-type'] = 'application/json;charset=utf-8';
    } else if (data && data instanceof Object) {
      options.headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8';
      _dataSubmit = '';
      for (var attrName in data) {
        _dataSubmit += attrName + '=' + data[attrName] + '&';
      }
      _dataSubmit = _dataSubmit.substring(0, _dataSubmit.length - 1);
    } else if (data) {
      options.headers['content-type'] = 'application/x-www-form-urlencoded;charset=utf-8';
      _dataSubmit = data;
    }

    axios.delete(API_PATH + path, _dataSubmit, options).then(response => {
      successCallBack(response);
    }).catch(error => {
      console.log(error);
      errorCallBack(error);
    });
  },

  postApiAjax(path, data, options, successCallBack, errorCallBack) {
    let defaultHeader = {
      'Authorization': 'Bearer ' + this.getAccessToken(),
      // 'Access-Control-Allow-Origin' : '*'
    }
    // eslint-disable-next-line no-undef
    let customOptions = $.extend(defaultHeader, options.headers);
    options.headers = customOptions;
    $.ajax({
      type: "POST",
      url: API_PATH + path,
      headers: customOptions,
      data: data,
      async: false,
      success: function (res) {
        successCallBack(res);
      },
      error: function (res) {
        errorCallBack(res);
      }
    });
  },
  setAccessToken(access_token) {
    localStorage.setItem('access_token', access_token);
  },
  getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_NAME);
  },
  setAuthorities(Authorities) {
    localStorage.setItem('Authorities', Authorities);
  },
  setUsername(username) {
    localStorage.setItem('username', username);
  },
  clearAccessToken() {
    localStorage.clear();
  },
  checkLogin() {
    let token = localStorage.getItem('access_token');
    return token !== null & typeof token !== 'undefined';
  },
  formatDate(milisecons) {
    if (milisecons === null || milisecons === '') {
      return '';
    } else {
      var moment = require('moment');
      return moment(milisecons).format("DD/MM/YYYY HH:mm:ss");
    }
  },
  formatDateDDMMYYYYHHMM(milisecons) {
    if (milisecons === null || milisecons === '') {
      return '';
    } else {
      var moment = require('moment');
      return moment(milisecons).format("DD/MM/YYYY HH:mm");
    }
  },
  formatDateDDMMYYYY(milisecons) {
    if (milisecons === null || milisecons === '') {
      return '';
    } else {
      var moment = require('moment');
      return moment(milisecons).format("DD/MM/YYYY");
    }
  },
  formatHHMM(milisecons) {
    if (milisecons === null || milisecons === '') {
      return '';
    } else {
      var moment = require('moment');
      return moment(milisecons).format("HH:mm");
    }
  },
  formatHHMMSS(milisecons) {
    if (milisecons === null || milisecons === '') {
      return '';
    } else {
      var moment = require('moment');
      return moment(milisecons).format("HH:mm:ss");
    }
  },
  formatDateDDMMYYYYHHMMSS(milisecons) {
    if (milisecons === null || milisecons === '') {
      return '';
    } else {
      var moment = require('moment');
      return moment(milisecons).format("DDMMYYYYHHMMSS");
    }
  },
  convertStringToDate(string, format) {
    if (string === null || string === '') {
      return '';
    } else {
      var moment = require('moment');
      return moment(string, format).toDate();
    }
  },
  convertStringTimeToDate(string, format) {
    var moment = require('moment');
    var cdt = moment(string, format);
    return cdt;
  },
  convertStringToArray(string, c) {
    if (string === null || string === '') {
      return '';
    } else {
      return string.split(c);
    }
  },
  plusDate(number, type) {
    if (number) {
      var moment = require('moment');
      return moment().add(number, type);
    }
    return moment();
  },
  minusDate(number) {
    if (number) {
      var moment = require('moment');
      return moment().subtract(number, type);
    }
    return moment();
  },
  subtractNowDate(number) {
    if (number) {
      var moment = require('moment');
      return moment().subtract(number, 'd').toDate();
    }
    return moment()
  },
  formatPrice(value) {
    if (value === null || value === '') {
      return '';
    } else {
      let val = (value / 1).toFixed(0).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
  },
  formatPriceString(priceStr) {
    if (priceStr === null || priceStr === '') {
      return '';
    } else {
      if (typeof priceStr === 'number') {
        priceStr = priceStr.toString();
        if (priceStr.startsWith('-')) {
          priceStr = priceStr.substring(1, priceStr.length);
        }
      }
      return priceStr.replace(/(?=(?:\d{3})+$)(?!^)/g, ',');
    }
  },
  formatNumberString(numberStr) {
    if (numberStr === null || numberStr === '') {
      return '';
    } else {
      if (typeof numberStr === 'number') {
        numberStr = numberStr.toString();
      }
      return numberStr.replace(/(?=(?:\d{3})+$)(?!^)/g, ',');
    }
  },
  setupInputNumberRequired(inputId, isFormatNumber) {
    let that = this,
      // eslint-disable-next-line no-undef
      $input = $('#' + inputId);
    if (isFormatNumber !== false) {
      $input.on('keyup', function () {
        let formattedVal = that.formatNumberString($input.val().replace(/,/g, ''));
        $input.val(formattedVal);
      });
    }

    $input.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
      if (/^\d*$/.test(this.value.replace(/,/g, ''))) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      }
    });
  },
  setupInputNumber(inputCLass) {
    // eslint-disable-next-line no-undef
    let $input = $('.' + inputCLass);
    $input.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
      if (/^\d*$/.test(this.value.replace(/,/g, ''))) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      }
    });
  },
  readBase64FromInput(id, objectResult, attrContent, callback) {
    let reader = new FileReader();
    reader.readAsDataURL(document.getElementById(id).files[0]);
    reader.onload = function () {
      objectResult[attrContent] = reader.result.split(',')[1];
      if (callback !== undefined) {
        callback();
      }
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  },
  isEmpty(myObject) {
    for (var key in myObject) {
      if (myObject.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  },
  setupTitleAction(action, object_type, object_name) {
    return `<span class="text-modal-important">${action}</span>&nbsp;${object_type}${object_name ? `&nbsp;<span class="text-modal-important">${object_name}</span>` : ''}`;
  },
  cloneObject(obj) {
    let copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) {
      return obj;
    }
    if (obj instanceof Date) { // Handle Date
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }
    if (obj instanceof Array) { // Handle Array
      copy = [];
      for (let i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.cloneObject(obj[i]);
      }
      return copy;
    }
    if (obj instanceof Object) { // Handle Object
      copy = {};
      for (let attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.cloneObject(obj[attr]);
      }
      return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
  },
  copyProperties(targetObj, sourceObj) {
    for (let attr in sourceObj) {
      targetObj[attr] = sourceObj[attr];
    }
  },
  isDataClone(thisValue, thatValue) {
    for (let thisAttrName in thisValue) {
      let thisAttrValue = thisValue[thisAttrName];
      let thatAttrValue = thatValue[thisAttrName];
      if (thisAttrValue instanceof Array && thisAttrValue.length !== thatAttrValue.length) {
        return false;
      }
      if (!(thisAttrValue instanceof Object) && thisAttrValue != thatAttrValue) {
        return false;
      } else if (thisAttrValue instanceof Object) {
        // return this.isDataClone(thisAttrValue, thatAttrValue);
      }
    }
    return true;
  },
  formatMobilePhone(phone) {
    if (phone === null || phone === '') {
      return '';
    } else {
      return phone.substr(0, 3) + 'xxxx' + phone.substr(7);
    }
  },
  downloadByURI(url, name) {
    let link = document.createElement("a");
    link.download = name;
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  async fetchAndDownloadByURI(url, name) {
    const res = await fetch(url, {
      headers: {
        'Authorization': 'Bearer ' + this.getAccessToken()
      }
    })
    const blob = await res.blob()
    const file = URL.createObjectURL(blob)
    let link = document.createElement("a");
    link.download = name;
    link.href = file;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  async blobFileByUrl(url) {
    const res = await fetch(url, {
      headers: {
        'Authorization': 'Bearer ' + this.getAccessToken()
      }
    })
    const blob = await res.blob()
    return URL.createObjectURL(blob)
  },
  async fetchToBlob(url) {
    const res = await fetch(url, {
      headers: {
        'Authorization': 'Bearer ' + this.getAccessToken()
      }
    })
    return await res.blob();
  },
  async blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  },
  encodeAES(data, key) {
    return AES.encrypt(data, key).toString();
  },
  decodeAES(data, key) {
    return AES.decrypt(data, key).toString(enc);
  },
  randomDataWithLength(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}
